import * as amplitude from '@amplitude/unified';

const amplitudeApiKey = import.meta.env.VITE_AMPLITUDE_API_KEY;

let amplitudeInitialized = false;
let amplitudeMissingKeyWarned = false;

export function isAmplitudeEnabled(): boolean {
    return Boolean(amplitudeApiKey);
}

export function ensureAmplitudeInit() {
    if (!amplitudeApiKey) {
        if (!amplitudeMissingKeyWarned) {
            console.warn('Amplitude API key missing — analytics disabled');
            amplitudeMissingKeyWarned = true;
        }

        return amplitude;
    }

    if (!amplitudeInitialized) {
        amplitude.initAll(amplitudeApiKey, {
            serverZone: 'EU',
            analytics: {
                autocapture: true
            },
            sessionReplay: {
                sampleRate: 1
            }
        });

        amplitudeInitialized = true;
    }

    return amplitude;
}

export function trackAmplitude(eventName: string, eventProperties?: Record<string, unknown>) {
    if (!isAmplitudeEnabled()) {
        return;
    }

    ensureAmplitudeInit();
    amplitude.track(eventName, eventProperties);
}
